<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-opne="beforeOpen">
        <div class="modal__header">
           <h1>{{$t('modals.start_employer_trajectory.title')}}</h1>
        </div>
        <div class="modal__content">
            <div v-if="uploadErrors.length" class="alert--error" >
                <span v-for="err in uploadErrors" :key="err"> {{ err }} </span>
            </div>
            <h2>{{$t('modals.start_employer_trajectory.choose_plan')}}</h2>
            <input v-if="!filesUploading" type="file" accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .bmp, .gif" name="planUpload" id="planUpload" ref="planUpload" style="display: none;" @change="onEmployerPlanSelected">
            <loading-button @submited="$refs.planUpload.click()" :loading="filesUploading" :text="$t('common.choose_file')"></loading-button>
            <span> {{plan ? plan.name : ''}} </span>

            <h2>{{$t('modals.start_employer_trajectory.upload_offer')}}</h2>
            <input v-if="!filesUploading" type="file" accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .bmp, .gif" name="offerUpload" id="offerUpload" ref="offerUpload" style="display: none;" @change="onOfferSelected">
            <loading-button @submited="$refs.offerUpload.click()" :loading="filesUploading" :text="$t('common.choose_file')" @complete="!uploadErrors.length && $modal.hide(name)"></loading-button>
            <span> {{offer ? offer.name : ''}} </span>
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" :class="{disabled: !plan || !offer || filesUploading}" :disabled="!plan || !offer || filesUploading" @click="uploadEmployerPlanAndOffer()">{{$t('modals.start_employer_trajectory.upload_and_start')}}</button>
                <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import { getFormatedDate } from '@/helpers';
    import ModalWrapper from '@/components/general/ModalWrapper';
    import LoadingButton from '@/components/general/LoadingButton';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { GET_DOCUMENTS } from '@/store/modules/documents';

    @Component({
        components: {
            LoadingButton,
        }
    })
    export default class TrajectoryStartEmployerModal extends Vue {
        name = 'trajectory-start-employer-modal';
        filesUploading = false;
        uploadErrors = [];
        plan = null;
        offer = null;

        beforeOpen() {
            this.uploadErrors = [];
            this.filesUploading = false;
            this.plan = null;
            this.offer = null;
        }

        onEmployerPlanSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.plan = files[0];
        }

        onOfferSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.offer = files[0];
        }

        uploadEmployerPlanAndOffer() {
            if (!this.plan || !this.offer) return;

            var formData = new FormData();
            formData.append('trajectory_plan', this.plan, this.plan.name);
            formData.append('proposal', this.offer, this.offer.name);

            this.filesUploading = true;
            this.uploadErrors = [];
            this.axios.post(`trajectories/${this.$store.state.trajectory.trajectory.id}/start-employer`, formData).then(res => {
                this.$notify.success(this.$t('notify.start_employer_trajectory.uploaded_and_sent'));
                this.$store.dispatch(GET_TRAJECTORY, {});
            }).catch(err => {
                if (err.status === 422 && err.errors) {
                    this.uploadErrors = err.errors;
                    this.$notify.error(this.$t('common.validation_error'));
                } else {
                    this.$notify.error(this.$t('notify.start_employer_trajectory.error'));
                }
            }).then(() => {
                this.filesUploading = false;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/TrajectoryStartEmployerModal.vue